<template>
  <div ml-3>
    <v-snackbar v-model="msg" top>
      {{ text }}
      <v-btn color="pink" text @click="msg = false"> Close</v-btn>
    </v-snackbar>
    <v-card>
        <v-card-title style="background-color: #2b3990">
          <span class="headline white--text">{{ titleForm  }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="4">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="newDate"
                      label="Date"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      :readonly="readonly"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="newDate"
                    no-title
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="menu = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu.save(date)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-select
                  v-model="newCategory"
                  label="Category"
                  :items="categories"
                  :readonly="readonly"

                ></v-select>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field
                  v-model="newTitle"
                  label="Title"
                  :readonly="readonly"

                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" >
                <v-textarea
                  v-model="newDescription"
                  label="Description"
                  outlined
                  :readonly="readonly"

                ></v-textarea>
              </v-col>
              <v-col cols="12" sm="12" >
                <v-textarea
                  v-model="newEmployeeResponse"
                  label="Employee Response"
                  outlined
                  :readonly="readonly"

                ></v-textarea>
              </v-col>
              <v-col cols="12" sm="12">
                <v-textarea
                  v-model="newDiscussionNotes"
                  label="Discussion Notes"
                  outlined
                  :readonly="readonly"

                ></v-textarea>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <span>Counseling Notice</span>
                <v-checkbox
                  v-model="newCounselingNotice"
                  label="Yes"
                  :readonly="readonly"

                ></v-checkbox>
              </v-col>
              <v-col cols="12">
                <v-col cols="12" sm="12" md="12">
                  <v-checkbox v-model="signed" label="Reviewed By Signature" @click="addSignature()"></v-checkbox>
                  <v-text-field
                    v-model="newReviewedBy"
                    label="ReviewedBy"
                    :readonly="readonly"

                  ></v-text-field>
                </v-col>
              </v-col>
              <v-col cols="12" sm="12">
              <form enctype="multipart/form-data">
               <v-file-input
                  v-model="newAdjustmentDocument"
                  class="pa-2"
                  label="Documents"
                  filled
                  multiple
                  prepend-icon="mdi-camera"
                  accept="image/*, .pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  @change="fileSelected"
                  show-size
                  :readonly="readonly"

                >
                  <template #selection="{ text, index }">
                    <v-chip small label close color="primary" @click:close="deleteChip(index)">{{ text }}</v-chip>
                  </template>
                </v-file-input>
            </form>
              </v-col>
              <v-col cols="12" sm="12" md="12"
                v-for="doc in newAdjustmentDocument"
                :key="doc.aws"
              >
                <div v-if="doc.ext !='pdf' ">
                  <v-img
                    max-height="480"
                    max-width="550"
                    :src="doc.aws"
                  ></v-img>
                </div>
                <div v-if="doc.ext =='pdf' ">
                  <load-pdf
                    :pdfFile="doc.aws"
                    :id="doc.id"
                  />
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#259647" class="white--text" @click="addAdjustment()" v-if="newAdjustment">
            Save
          </v-btn>
          
          <v-btn
            fab
            small
            @click="showPrintModal()"
            class="mr-8 mb-2 white--text"
            color="#2b6993"
            elevation="4"
            v-if="editAdjustment">
            <v-icon>print</v-icon>
          </v-btn>

          <v-btn color="#259647" class="white--text"
                 @click="updateAdjustment()"
                 v-if="editAdjustment"
                 v-show="Role === 'Administration' || 
                  Role === 'Human Resources' || 
                  Role === 'Client Services Manager' || 
                  Role === 'Compliance Manager'"
          >
            Update
          </v-btn>
          <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </div>
</template>
<script>
  import axios from 'axios';
  import renameFileHelper from '@/mixins/renameFileHelper';
  import PrintUtil from "../../../utils/print-util";
  
  const url = require("@/client_config/config").url;

export default {
  mixins: [renameFileHelper],
  data: function() {
    return {
      titleForm: 'Adjustment Form',
      newDate: '',
      newCategory: '',
      newTitle: '',
      newDescription: '',
      newEmployeeResponse: '',
      newDiscussionNotes: '',
      newCounselingNotice: '',
      newReviewedBy: '',
      newAdjustmentDocument: [],
      categories: ["Tardy", "Absent"],
      readonly: false,
      signed: false,
      staff: "",
      users: [],
      userID: localStorage.getItem("userID"),
      uploadFile: "",
      employeeID: this.$route.params.employeeID,
      newStaffSignature: "",msg: false,
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu: false,
      text:"",
      adjustmentID: this.$route.params.id,
      Role: localStorage.getItem('userRole'),      
      token: localStorage.getItem('token'),
    }
  },

  created() {
    this.getUsers();
    if (this.adjustmentID) {
      this.viewAdjustment();
    }
  },

  async mounted() {
      window.addEventListener('keydown', async (event) => {
          PrintUtil.handleKeydown(event, this.generateDownloadUrl, this.adjustmentID, this.token, 'adjustment');
      });
  },

  beforeDestroy() {
        window.removeEventListener('keydown', (event) => {
            PrintUtil.handleKeydown(event, this.generateDownloadUrl, this.adjustmentID, this.token,'adjustment');
        });
    },

  computed: {
    staffName() {
      return this.$store.state.staff.staff.Name;
    },
    formTitle() {
      return this.editedIndex != 1 ? "New Item" : "Edit Item";
    },
    newAdjustment() {
      return this.$route.params.action == 'add' ? true : false;
    },
    editAdjustment() {
      return this.$route.params.action == 'edit' ? true : false;
    },
    generateDownloadUrl() {      
      return `${url}/adjustments/download/${this.adjustmentID}`;
    }
  },
  methods: {
    addSignature: function() {
      if(!this.signed) return this.newReviewedBy = ''
      this.newReviewedBy = this.staff + " - " + new Date();
    },
    getUsers: function() {
      axios.get(`${url}/users`).then(async res => {
          this.users = res.data.users;
          for (var i=0; i < this.users.length; i++){
            if (this.userID == this.users[i]._id) {
              this.staff = this.users[i].Name
            }
          }
      });
    },      
    deleteChip(index) {
      this.newAdjustmentDocument.splice(index, 1);
    },  

    addAdjustment: function() {
      var req_body = {
        Date: this.newDate,
        Title: this.newTitle,
        Description: this.newDescription,
        EmployeeResponse: this.newEmployeeResponse,
        DiscussionNotes: this.newDiscussionNotes,
        CounselingNotice: this.newCounselingNotice,
        ReviewedBy: this.newReviewedBy,
        StaffSignature: this.newStaffSignature,
        AdjustmentDocument: this.newAdjustmentDocument,
        EmployeeID: this.employeeID,
        Category: this.newCategory,
      };

        axios.post(`${url}/adjustments`, req_body ).then(res => {
        if (res.status == 400) {
          res.json().then(function(data) {
            this.text=data.msg;
          });
        }
        this.msg =true;
        this.text ="The new adjustment has been added successfully.";
        this.adjustmentID = res.data._id
        this.saveFile();
        setTimeout(this.$router.go(-1), 1000);
      });
    },    

    async fileSelected(e) {
      this.uploadFile= await this.renameFileHelper(e, this.staffName, "Adjustment", this.newDate);
    },

    saveFile() {
      this.message = "";
      for (let i = 0; i < this.uploadFile.length; i++) {
        this.uploadFiles(this.uploadFile[i]);
      }
    },

    uploadFiles(file) {

      const formData = new FormData();
      formData.append('adjustment', file);
      var ct = { headers:{"content-type" : "multipart/form-data"}};
      axios.post(`${url}/adjustments/fileuploader/${this.adjustmentID}/${this.employeeID}`,formData, ct)
      .then(res => {
        if(res){
          const adjustmentIndex = this.adjustments.findIndex(adjustment => adjustment._id === this.adjustmentID);
          if (adjustmentIndex !== -1) {
            this.adjustments[adjustmentIndex].documents.push(res.data.file);
          }
        }
      })
      .catch(err => {
        console.log(err);
      });
    },

    close() {
      this.$router.go(-1);
    },

    viewAdjustment() {
      axios.get(`${url}/adjustments/${this.adjustmentID}` ).then(res => {
        const item = res.data.adjustment[0];
        this.newDate= item.Date;
        this.newTitle= item.Title;
        this.newDescription= item.Description;
        this.newEmployeeResponse= item.EmployeeResponse;
        this.newDiscussionNotes= item.DiscussionNotes;
        this.newCounselingNotice= item.CounselingNotice;
        this.newReviewedBy= item.ReviewedBy;
        this.newStaffSignature= item.StaffSignature;

        const tempData = [];
        if (item.documents.length > 0) {
          for (let i = 0; i < item.documents.length ; i++) {
            let fileExt = item.documents[i].AWSLink.split('.').pop();
            tempData.push({
              name: item.documents[i].Name,
              id:  item.documents[i]._id,
              aws: item.documents[i].AWSLink,
              ext: fileExt
            });
          }
          this.newAdjustmentDocument = tempData;
          this.newCategory= item.Category;
        }
      });
    },

    updateAdjustment() {
      var req_body = {
        Date: this.newDate,
        Title: this.newTitle,
        Description: this.newDescription,
        EmployeeResponse: this.newEmployeeResponse,
        DiscussionNotes: this.newDiscussionNotes,
        CounselingNotice: this.newCounselingNotice,
        ReviewedBy: this.newReviewedBy,
        StaffSignature: this.newStaffSignature,
        AdjustmentDocument: this.newAdjustmentDocument,
        Category: this.newCategory,
      };
      axios.put(`${url}/adjustments/${this.adjustmentID}`, req_body).then((response) => {
        if (response.status == 400) {
          response.json().then(function(data) {
            alert(data.msg);
          });
        }
        this.msg =true;
        this.text ="The adjustment has been updated successfully.";
        this.saveFile()
      });
      this.close();
    },

    async showPrintModal() {
      console.log(this.generateDownloadUrl);
        PrintUtil.showPrintOption(this.generateDownloadUrl, this.adjustmentID, this.token,'adjustment');
    },
    
  }
}
</script>